import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Footer = () => {
  const footerRef = useRef(null);
  const taglineRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Tagline fade in with sprinkle trail
      gsap.fromTo(taglineRef.current,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: footerRef.current,
            start: 'top 90%',
            toggleActions: 'play none none none'
          },
          onStart: () => createSprinkleTrail()
        }
      );
    }, footerRef);

    return () => ctx.revert();
  }, []);

  const createSprinkleTrail = () => {
    const colors = ['#ec4899', '#14b8a6', '#fbbf24', '#f97316'];
    const container = footerRef.current;
    
    for (let i = 0; i < 10; i++) {
      setTimeout(() => {
        const sprinkle = document.createElement('div');
        sprinkle.className = 'absolute w-2 h-2 rounded-full';
        sprinkle.style.backgroundColor = colors[i % colors.length];
        sprinkle.style.left = '50%';
        sprinkle.style.top = '20px';
        container.appendChild(sprinkle);

        gsap.to(sprinkle, {
          x: (Math.random() - 0.5) * 200,
          y: -50,
          opacity: 0,
          duration: 1.5,
          ease: 'power2.out',
          onComplete: () => sprinkle.remove()
        });
      }, i * 100);
    }
  };

  return (
    <footer ref={footerRef} className="relative py-16 px-4 bg-gradient-to-br from-amber-900 to-pink-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Sprinkle Divider */}
        <div className="flex justify-center space-x-3 mb-8">
          {[...Array(5)].map((_, i) => (
            <span
              key={i}
              className="inline-block w-3 h-3 rounded-full animate-pulse"
              style={{
                backgroundColor: ['#ec4899', '#14b8a6', '#fbbf24', '#f97316', '#ec4899'][i],
                animationDelay: `${i * 0.2}s`
              }}
            />
          ))}
        </div>

        <div className="text-center">
          <h3 ref={taglineRef} className="text-3xl md:text-4xl font-bold mb-6">
            A Sweeter Way to Give
          </h3>
          {/* <p className="text-amber-200 text-lg mb-8">
            Every order supports the charity of your choice.
          </p> */}
          
          <div className="mb-8">
            <p className="text-2xl font-bold mb-2">
              <span className="text-amber-300">Dough</span>
              <span className="text-pink-300">-</span>
              <span className="text-amber-300">nate</span>
            </p>
          </div>

          <div className="border-t border-amber-700 pt-6">
            <p className="text-amber-300">
              © {new Date().getFullYear()} Dough-nate.co.uk - All rights reserved.
            </p>
            <p className='text-amber-300' href="www.picsoft.co.uk" >Powered by PICSOFT LTD</p>
          </div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute top-10 left-10 w-20 h-20 rounded-full bg-amber-500 opacity-10 blur-2xl"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 rounded-full bg-pink-500 opacity-10 blur-3xl"></div>
    </footer>
  );
};

export default Footer;